import { createClient, User } from '@supabase/supabase-js';
import { Database } from './db';
import { Missionary, Subscriber } from './types';

// const supabase = createClient(`${process.env.REACT_APP_SUPABASE_URL}`,`${process.env.REACT_APP_SUPABASE_ANON_KEY}`);

// TODO: Use environment variables with this
export const supabase = createClient(
    process.env.REACT_APP_SUPABASE_URL!,
    process.env.REACT_APP_SUPABASE_ANON_KEY!
);

export async function getSession() {
    const res = await supabase.auth.getSession();
    console.log(res);
    return res.data.session;
}

export async function signInWithPassword(email: string, password: string) {
    return await supabase.auth.signInWithPassword({ email: email, password: password });
}

export async function signUpWithPassword(email: string, password: string) {
    return await supabase.auth.signUp({
        email: email,
        password: password,
        options: {
            emailRedirectTo: 'http://app.pressforwardmail.com/dashboard' // TODO: Set this as an environment variable
        }
    });
}

export async function requestPasswordReset(email: string, redirectTo?: string) {
    return await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: redirectTo || `${window.location.origin}/reset-password`
    });
}

export async function resetPassword(password: string) {
    return await supabase.auth.updateUser({ password: password });
}

export async function signout() {
    return await supabase.auth.signOut();
}

export async function getMissionariesByUser(user: User): Promise<Missionary[]> {
    const res = await supabase
        .from('missionary')
        .select('missionary_id, name, email, unique_id, assigned_mission, start_date')
        .filter('user_id', 'eq', user.id);
    return res.data as Missionary[];
}

export async function getMissionaryByUniqueId(id: string): Promise<Missionary | null> {
    console.log(id);
    const res = await supabase
        .from('missionary')
        .select('missionary_id, name, email, unique_id, assigned_mission, start_date')
        .filter('unique_id', 'eq', id);
    console.log(res);
    if (res.data) {
        return res.data[0] as Missionary;
    }
    return null;
}

export async function insertMissionary(missionary: Missionary) {
    return await supabase.from('missionary').insert(missionary);
}

export async function editMissionary(missionary: Missionary) {
    await supabase.from('missionary').update(missionary).eq('unique_id', missionary.unique_id);
}

export const deleteMissionary = async (missionary: Missionary) => {
    if (missionary.unique_id) {
        const { error } = await supabase
            .from('missionary')
            .delete()
            .eq('unique_id', missionary.unique_id);

        if (error) {
            throw error;
        }
    } else {
        throw Error('Missionary does not have a unique_id.');
    }
};

export async function insertSubscriber(subscriber: Subscriber) {
    await supabase.from('subscriber').insert(subscriber);
}

export async function getSubscribersByMissionary(id: string) {
    const res = await supabase
        .from('subscriber')
        .select('subscriber_id, email, missionary, active, verified')
        .filter('missionary', 'eq', id);
    return res.data as Subscriber[];
}

export async function deleteSubscriber(subscriber: Subscriber) {
    const { data, error } = await supabase.functions.invoke('unsubscribe', {
        body: {
            email: subscriber.email,
            missionary: subscriber.missionary,
            type: 'single'
        }
    });
    if (error) throw error;
    return data;
}

export async function deleteAllSubscriptions(email: string) {
    const { data, error } = await supabase.functions.invoke('unsubscribe', {
        body: {
            email: email,
            type: 'all'
        }
    });
    if (error) throw error;
    return data;
}

export async function getMissionaryByUniqueIdForUnsubscribe(uniqueId: string) {
    const res = await supabase.from('missionary').select('name').eq('unique_id', uniqueId);
    return res.data?.[0] || null;
}

export async function editSubscriber(subscriber: Subscriber) {
    const res = await supabase.from('subscriber').upsert(subscriber);
    return res;
}

export async function getPage(name: string) {
    const res = await supabase.from('pages').select('name, content').filter('name', 'eq', name);
    if (res !== null && res.data !== null && res.data.length > 0) {
        return res.data[0];
    } else {
        return null;
    }
}

export async function getPlans() {
    const res = await supabase.from('plans').select('id, name, price, duration, description');
    console.log(res);
    if (res !== null && res.data !== null) {
        return res.data;
    } else {
        return null;
    }
}
